if($('.type-detail').length){
    $('.slozeni .right').html($('.extended-description table'))
    $('.p-detail-inner-header').clone().appendTo('.p-info-wrapper, .p-image-wrapper')

    var attrsrc = $('.p-image>a>img').attr('src').replace('/big/', '/orig/')
    $('.p-image>a>img').attr('src', attrsrc)
    $('.p-info-wrapper').append('<div class="kosik"><div class="left"></div><div class="right"></div></div>')
    $('.p-short-description ul').appendTo('.kosik .right')
    $('.availability-value').appendTo('.kosik .left')
    $('.p-final-price-wrapper').appendTo('.kosik .left')
    $('.add-to-cart').appendTo('.kosik .left')
    $(".price-final-holder").each(function() {
        $(this).html(function(){
          return $(this).html().replace("Kč", ",-");
        })
    })
    
}